if (!customElements.get('product-modal-dialog-by-target')) {
  customElements.define(
    'product-modal-dialog-by-target',
    class ProductGenericHandlerModal extends ModalDialog {
      constructor() {
        super();

        const target = String(this.dataset.target).toLocaleLowerCase();

        window.addEventListener('load', () => {
          document.querySelectorAll('[href="' + target + '"]').forEach((link) => {
            link.addEventListener('click', (event) => {
              event.preventDefault();

              super.show(link);
            });
          });
        });
      }
    },
  );
}
